import cn from 'classnames';
import React, { memo } from 'react';

import Button from 'components/molecules/button';

import sm from './styles.module.scss';
import { Props } from './types';

export const ModalButtons = ({
  withTopButtonsMargin,
  rejectConfig,
  submitConfig,
}: Props) => (
  <div
    className={cn(sm.Box, {
      [sm.Buttons_WithMargin]: withTopButtonsMargin,
    })}
  >
    {rejectConfig && (
      <Button
        label={rejectConfig?.label ?? 'Cancel'}
        isOutlined
        onClick={rejectConfig?.onClick}
        isDisabled={rejectConfig?.isDisabled}
      />
    )}
    {submitConfig && (
      <Button
        label={submitConfig.label ?? 'Save'}
        type={submitConfig.onClick ? 'button' : 'submit'}
        isDisabled={submitConfig.isDisabled}
        isDanger={submitConfig.isDanger}
        onClick={submitConfig.onClick}
      />
    )}
  </div>
);

export default memo(ModalButtons);
